import * as Sentry from '@sentry/react';
import type { AnalyticsService } from '@repo/core';

/**
 * Web analytics implementation using Sentry breadcrumbs.
 * Swap this for PostHog, Mixpanel, etc. by implementing AnalyticsService.
 *
 * Mobile (Capacitor): use the same class or swap at DI registration.
 */
export class SentryAnalyticsService implements AnalyticsService {
  track(event: string, properties?: Record<string, unknown>) {
    Sentry.addBreadcrumb({
      category: 'user.action',
      message: event,
      data: properties,
      level: 'info',
    });
  }

  identify(userId: string, traits?: Record<string, unknown>) {
    Sentry.setUser({ id: userId, ...traits });
  }

  page(name: string, properties?: Record<string, unknown>) {
    Sentry.addBreadcrumb({
      category: 'navigation',
      message: name,
      data: properties,
      level: 'info',
    });
  }

  reset() {
    Sentry.setUser(null);
  }
}
